// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__39maC","title":"Header_title__T0eET","left":"Header_left__3STGj","clinicName":"Header_clinicName__VCWIv"};